export default __webpack_public_path__ + "static/media/FoxLakeLogo.1276e140.png";